module.exports = __webpack_public_path__ + "static/media/sofa-3.bce0c0d0.webp";